import React, { useEffect } from 'react'
import { useThemeAccent } from '../contexts/ThemeAccentContext'
import { resolveAccentMain } from './accentPresets'

const FAVICON_SIZE = 64

/** Vẽ favicon túi mua + check trên nền accent (theo theme). */
function buildMuahangFaviconDataUrl(primaryMain: string): string {
  const canvas = document.createElement('canvas')
  canvas.width = FAVICON_SIZE
  canvas.height = FAVICON_SIZE
  const ctx = canvas.getContext('2d')
  if (!ctx) return ''

  const r = 14
  ctx.beginPath()
  ctx.moveTo(r, 0)
  ctx.arcTo(FAVICON_SIZE, 0, FAVICON_SIZE, FAVICON_SIZE, r)
  ctx.arcTo(FAVICON_SIZE, FAVICON_SIZE, 0, FAVICON_SIZE, r)
  ctx.arcTo(0, FAVICON_SIZE, 0, 0, r)
  ctx.arcTo(0, 0, FAVICON_SIZE, 0, r)
  ctx.closePath()
  ctx.fillStyle = primaryMain
  ctx.fill()

  ctx.fillStyle = '#ffffff'
  ctx.strokeStyle = '#ffffff'
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'

  // Tay cầm túi
  ctx.lineWidth = 4.5
  ctx.beginPath()
  ctx.arc(32, 20, 9, Math.PI * 1.05, Math.PI * 1.95, false)
  ctx.stroke()

  // Thân túi
  ctx.beginPath()
  ctx.moveTo(18, 24)
  ctx.lineTo(46, 24)
  ctx.lineTo(49, 52)
  ctx.quadraticCurveTo(32, 56, 15, 52)
  ctx.closePath()
  ctx.fill()

  // Check (cutout màu accent)
  ctx.strokeStyle = primaryMain
  ctx.lineWidth = 4
  ctx.beginPath()
  ctx.moveTo(24, 38)
  ctx.lineTo(30, 44)
  ctx.lineTo(41, 31)
  ctx.stroke()

  return canvas.toDataURL('image/png')
}

/** Cập nhật favicon tab + theme-color theo accent. */
const ThemeFaviconUpdater: React.FC = () => {
  const { accentId } = useThemeAccent()
  const primaryMain = resolveAccentMain(accentId)

  useEffect(() => {
    if (typeof document === 'undefined') return

    const href = buildMuahangFaviconDataUrl(primaryMain)
    if (!href) return

    const apply = (link: HTMLLinkElement) => {
      link.rel = 'icon'
      link.type = 'image/png'
      link.href = href
      try {
        link.sizes.add('32x32')
      } catch {
        /* ignore */
      }
    }

    const existing = document.querySelector("link[rel='icon']") as HTMLLinkElement | null
    if (existing) {
      apply(existing)
    } else {
      const link = document.createElement('link')
      apply(link)
      document.head.appendChild(link)
    }

    const meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null
    if (meta) meta.content = primaryMain
  }, [primaryMain])

  return null
}

export default ThemeFaviconUpdater
